module.exports = __webpack_public_path__ + "static/media/djsb-physical.02bbcb7f.png";